// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__OVisL","container":"styles_container__3fiRN"};